export default __webpack_public_path__ + "static/media/Time_HTB.22cb38d3.md";